import { render, staticRenderFns } from "./editarticle.vue?vue&type=template&id=0a70be4e&scoped=true"
import script from "./editarticle.vue?vue&type=script&lang=js"
export * from "./editarticle.vue?vue&type=script&lang=js"
import style0 from "./editarticle.vue?vue&type=style&index=0&id=0a70be4e&prod&scoped=true&lang=css"
import style1 from "./editarticle.vue?vue&type=style&index=1&id=0a70be4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a70be4e",
  null
  
)

export default component.exports